<template>
  <div v-if="document">
    <div class="row">
      <div class="col-md-6">
        <BreadCrumd
          :title="'Demandes de recrutement'"
          :description="'Modification d\'une demande de recrutement'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6 text-custom-primary">
                    Référence : {{ document.reference }}
                  </td>
                  <td class="col-6">
                    Statut :
                    <i
                      :class="[
                        {
                          'text-warning': form.statut === CONST.EN_ATTENTE,
                          'text-success':
                            form.statut === CONST.VALIDER ||
                            form.statut === CONST.OFFRE,
                          'text-danger': form.statut === CONST.REFUSER,
                        },
                        icons.ICON_STATUT,
                        'mr-1',
                      ]"
                    ></i>
                    {{ getStatutPO(form.statut) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="
            $router.push({ name: 'rh_proposition_offre' }).catch(() => {})
          "
        >
          Liste des propositions
        </button>

        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router
              .push({ name: 'rh_proposition_offre-create' })
              .catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Nouvelle demande
        </button>

        <button
          v-if="form.statut === 0"
          type="button"
          class="btn btn-custom-primary"
          style="min-width: 100px"
          @click.prevent="
            $router
              .push({
                name: 'rh_proposition_offre-show',
                params: { id: id },
              })
              .catch(() => {})
          "
        >
          <i :class="icons.ICON_SHOW" class="font-size-17"></i> Aperçu
        </button>
      </div>
      <div class="col-md-12 col-lg-6">
        <b-button
          variant="success"
          class="btn-icon mr-4"
          @click="valider"
          v-if="form.statut === CONST.EN_ATTENTE"
        >
          <span class="btn-icon-label">
            <i :class="icons.ICON_VALIDATE"></i>
          </span>
          Valider
        </b-button>
        <b-button
          variant="danger"
          class="btn-icon mr-4"
          @click="refuser"
          v-if="form.statut === CONST.EN_ATTENTE"
        >
          <span class="btn-icon-label">
            <i :class="icons.ICON_REFUSE"></i>
          </span>
          Réfuser
        </b-button>

        <b-button
          variant="warning"
          class="btn-icon"
          @click="reinitialiser"
          v-if="form.statut !== CONST.EN_ATTENTE"
        >
          <span class="btn-icon-label">
            <i :class="icons.ICON_RESET"></i>
          </span>
          Réinitialiser
        </b-button>

        <button
          v-if="form.statut === CONST.VALIDER"
          type="button"
          title="Transformer en offre d'emploi"
          class="btn btn-custom-primary ml-4"
          @click.prevent="
            $router
              .push({
                name: 'rh_offre_emploi-create',
                params: { filter: 'po', id: form.id },
              })
              .catch(() => {})
          "
        >
          <i :class="icons.ICON_TRANSFORM" class="font-size-17"></i> Offre
          d'emploi
        </button>
      </div>
    </div>
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row">
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="poste"
                        >Poste <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="postes"
                        :reduce="(poste) => poste.uuid"
                        v-model="form.poste"
                        placeholder="Poste"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="poste"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('poste'),
                          }"
                        />
                        <has-error :form="form" field="poste"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="poste"
                        >Nature du poste
                        <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="naturePostes"
                        :reduce="(naturePoste) => naturePoste.uuid"
                        v-model="form.nature_poste"
                        placeholder="Nature du poste"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="poste"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('nature_poste'),
                          }"
                        />
                        <has-error
                          :form="form"
                          field="nature_poste"
                        ></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="poste"
                        >Type de contrat
                        <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="contratTypes"
                        :reduce="(contratType) => contratType.uuid"
                        v-model="form.contrat_type"
                        placeholder="Type de contrat"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="poste"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('contrat_type'),
                          }"
                        />
                        <has-error
                          :form="form"
                          field="contrat_type"
                        ></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-2">
                    <div class="form-group">
                      <label for="nbre_poste"
                        >Nombre de poste
                        <span class="text-danger">*</span></label
                      >
                      <div class="input-group">
                        <div
                          class="input-group-prepend bg-transparent"
                          @click="
                            form.nbre_poste =
                              form.nbre_poste - 1 > 0 ? form.nbre_poste - 1 : 1
                          "
                        >
                          <span
                            class="input-group-text bg-transprent border-right-0"
                            role="button"
                          >
                            <i
                              :class="icons.ICON_DECREASE"
                              class="text-danger"
                            ></i>
                          </span>
                        </div>
                        <input
                          type="text"
                          class="form-control text-center"
                          :class="{
                            'is-invalid': form.errors.has('nbre_poste'),
                          }"
                          id="nbre_poste"
                          v-model.number="form.nbre_poste"
                          placeholder="Nombre de poste"
                          required
                        />
                        <div
                          class="input-group-append bg-transparent"
                          @click="form.nbre_poste++"
                        >
                          <span
                            class="input-group-text bg-transprent border-left-0"
                            role="button"
                          >
                            <i :class="icons.ICON_ADD" class="text-success"></i>
                          </span>
                        </div>
                      </div>
                      <has-error :form="form" field="nbre_poste"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-3">
                    <div class="form-group">
                      <label for="date_embauche"
                        >Date embauche souhaitée
                        <span class="text-danger">*</span></label
                      >
                      <date-picker
                        v-model="form.date_embauche"
                        name="date_embauche"
                        placeholder="Date d'embauche souhaitée"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date_embauche'),
                        }"
                        type="hidden"
                      />
                      <has-error :form="form" field="date_embauche"></has-error>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row">
                  <div class="col-md-12 col-lg-4">
                    <div class="form-group">
                      <label for="motif"
                        >Motif (max : 200 caractères )
                        <span class="text-danger">*</span></label
                      >
                      <textarea
                        v-model="form.motif"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('motif'),
                        }"
                        rows="5"
                        maxlength="200"
                      ></textarea>
                      <has-error :form="form" field="motif"></has-error>
                    </div>
                  </div>
                  <div class="col-md-12 col-lg-4">
                    <div class="form-group">
                      <label for="diplome_formation"
                        >Diplômes / formations (max : 200 caractères )
                        <span class="text-danger">*</span>
                      </label>
                      <textarea
                        v-model="form.diplome_formation"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('diplome_formation'),
                        }"
                        rows="5"
                        maxlength="200"
                      ></textarea>
                      <has-error
                        :form="form"
                        field="diplome_formation"
                      ></has-error>
                    </div>
                  </div>
                  <div class="col-md-12 col-lg-4">
                    <div class="form-group">
                      <label for="experience"
                        >Expérience (max : 200 caractères )
                        <span class="text-danger">*</span></label
                      >
                      <textarea
                        v-model="form.experience"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('experience'),
                        }"
                        rows="5"
                        maxlength="200"
                      ></textarea>
                      <has-error :form="form" field="experience"></has-error>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <b-alert
          :show="form.errors.has('fonction_mission')"
          dismissible
          variant="danger"
          class="mt-1"
        >
          <span v-html="form.errors.get('fonction_mission')"></span>
        </b-alert>

        <div class="row">
          <div class="col-md-12">
            <b-card
              class="text-black"
              header-class="bg-silver border-bottom-0"
              no-body
            >
              <template #header>
                <div>
                  <h5 class="font-size-16 mb-0">
                    <i :class="icons.ICON_DESCRIPTION" class="mr-0"></i>
                    Fonctions / missions
                  </h5>
                </div>
              </template>
              <div class="row editor">
                <div class="col-md-12">
                  <vue-editor
                    id="fonction-mission"
                    v-model="form.fonction_mission"
                    :editorToolbar="VueEditorToolbar"
                    class="fonction-mission"
                  />
                </div>
              </div>
            </b-card>
          </div>
        </div>

        <div class="row mb-4 mt-4">
          <div class="col-md-12 text-right">
            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Enregistrer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL from '@/http/rh/proposition-offre';
import Form from 'vform';
import DatePicker from 'vue2-datepicker';
import { VueEditor } from 'vue2-editor';
import VueEditorToolbar from '@/vue-editor-tool-bar';
import CONST from '@/constants/rh/proposition-offre';

export default {
  data() {
    return {
      form: new Form({
        nbre_poste: 0,
        experience: '',
        date_embauche: '',
        diplome_formation: '',
        motif: '',
        fonction_mission: '',
        poste: '',
        nature_poste: '',
        contrat_type: '',
      }),
      CONST,
      document: null,
      postes: [],
      naturePostes: [],
      contratTypes: [],
      cloneId: null,
      VueEditorToolbar,

      title: 'Gestion des demandes de recrutement - Edition',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  components: {
    DatePicker,
    VueEditor,
  },
  methods: {
    onChangeStatut() {
      this.$router.push({
        name: 'rh_proposition_offre-show',
        params: { id: this.id },
      });
    },
    valider() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.VALIDER + '/' + this.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.onChangeStatut();
            })
            .catch();
        }
      });
    },
    refuser() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.REFUSER + '/' + this.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.onChangeStatut();
            })
            .catch();
        }
      });
    },
    reinitialiser() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.REINITIALISER + '/' + this.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.onChangeStatut();
            })
            .catch();
        }
      });
    },
    init() {
      this.postes = [];
      this.naturePostes = [];
      this.contratTypes = [];

      this.id = this.$route.params.id;

      window.axios
        .all([
          window.axios.get(URL.GET_REQUIREMENTS),
          window.axios.get(URL.PROPOSITION_OFFRE + '/' + this.id, {
            params: { edit: true },
          }),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            this.postes = resp1.data.postes;
            this.naturePostes = resp1.data.nature_postes;
            this.contratTypes = resp1.data.contrat_types;
            Object.assign(this.form, resp2.data.proposition_offre);
            this.document = this.form.document;
            delete this.form.document;
          })
        )
        .catch();
    },

    submit() {
      this.form
        .put(URL.PROPOSITION_OFFRE + '/' + this.id)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.init();
        })
        .catch((err) => {
          this.form.errors.set('message', err.response.data.message);
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.zui-wrapper {
  position: relative;
}
.zui-scroll {
  overflow-x: scroll;
  overflow-y: visible;
  padding-bottom: 5px;
}
.zui-table {
  left: 0;
  top: auto;
  width: 2400px;
}
</style>
